export default __webpack_public_path__ + "6cffd276ab8952dda3dbddf84a483efd.png";